
export function GetEnv(name, defaultValue) {
    // console.log(`GetEnv(${name}, ${defaultValue})`);
    var value;
    if ((undefined === name) || (null === name) || (0 === name.length)) {
        value = defaultValue;
    }
    else {
        value = process.env[name];
        if ((undefined === value) || (null === value) || (0 === value.length)) {
        //   console.log(`GetEnv(${name}, ${defaultValue}) using default`);
          value = defaultValue;
        }
    }
    // console.log(`GetEnv(${name}, ${defaultValue}) returning ${value}`);
    return value;
}

export function GetUrlDerivedOrEnv(derived, name, defaultValue) {
    // console.log(`GetUrlDerivedOrEnv(${derived}, ${name}, ${defaultValue}) `, window.location);
    if ((undefined === derived) || (null === derived) || (0 === derived.length)) {
        return GetEnv(name, defaultValue);
    }
    else {
        return derived;
    }
}